import PhoneInput from './PhoneInput';
export default PhoneInput;
